"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeRefs = exports.fractionTakeUntill = exports.formatNumber = exports.normalizeNumber = exports.takeUntill = exports.pipe = void 0;
require("react");
const constants_1 = require("./constants");
const pipe = (...ops) => ops.reduce((a, b) => (arg) => b(a(arg)));
exports.pipe = pipe;
const takeUntill = (amount) => (str) => str.length <= amount ? str : str.slice(0, amount);
exports.takeUntill = takeUntill;
const normalizeNumber = (str) => str.replace(/,,|\.\.|\.,|,\.|,/, '.').replace(/[^.|\d]/g, '');
exports.normalizeNumber = normalizeNumber;
const formatNumber = (digitFraction) => (str) => {
    const [digit, fraction] = str.split('.');
    const base = digit.replace(constants_1.DIGIT_FORMATTER_REGEX, constants_1.DIGIT_SECTION_DELIMITER);
    const fractional = digitFraction && fraction !== undefined
        ? constants_1.FRACTION_DELIMITER + fraction.slice(0, digitFraction)
        : '';
    return base + fractional;
};
exports.formatNumber = formatNumber;
const fractionTakeUntill = (amount) => (str) => {
    const [digit, fraction] = str.split('.');
    return fraction ? [digit, (0, exports.takeUntill)(amount)(fraction)].join('.') : str;
};
exports.fractionTakeUntill = fractionTakeUntill;
const mergeRefs = (source, ...targets) => {
    if (typeof window !== 'undefined') {
        requestAnimationFrame(() => {
            targets.forEach((target) => {
                if (source && target) {
                    target.current = source.current;
                }
            });
        });
    }
    return source;
};
exports.mergeRefs = mergeRefs;
